import React, { useMemo } from 'react';

function HandleTimer({ time, position = 'center', showLabel = true }) {
  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    if (hours > 0) {
      return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    return `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  };

  const GREETINGS = {
    night: [
      'I see the hour is late',
      'Burning the midnight oil',
      'The quiet hours are yours',
      'The kids are asleep (I hope) and you\'re still going strong',
    ],
    morning: [
      'Good morning',
      "It's a great day to be alive",
      'A fresh start awaits',
      "Isla, Luca, and Alexis are your world",
      'The universe provides',
      'Coffee and build'
    ],
    afternoon: [
      'Good afternoon',
      'Keep the momentum going',
      'The kingdom of heaven is within you',
      'You\'re halfway through the day'
    ],
    evening: [
      'Good evening',
      'The days stretch on',
      'Putting in the extra hours',
      'The night is young',
      'You find the time'
    ],
  };

  const BLOCK_OFFSET = { night: 0, morning: 1, afternoon: 2, evening: 3 };

  const labelText = useMemo(() => {
    const now = new Date();
    const currentHour = now.getHours();

    let block;
    if (currentHour < 5) {
      block = 'night';
    } else if (currentHour < 12) {
      block = 'morning';
    } else if (currentHour < 18) {
      block = 'afternoon';
    } else {
      block = 'evening';
    }

    const pool = GREETINGS[block];
    const daySeed =
      now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
    const index = (daySeed + BLOCK_OFFSET[block]) % pool.length;
    const greeting = pool[index];

    const dayOfWeek = now.toLocaleDateString('en-US', { weekday: 'long' });
    const month = now.toLocaleDateString('en-US', { month: 'long' });
    const dayOfMonth = now.getDate();

    return { greeting, dayOfWeek, month, dayOfMonth };
  }, []);

  return (
    <div className={`timer timer--${position}`}>
      <div
        className={`timer__label ${showLabel ? 'timer__label--visible' : 'timer__label--hidden'
          }`}
      >
        <p className="timer__greeting">{labelText.greeting}, Harry.</p>
      </div>

      <p className="timer__time">{formatTime(time)}</p>

      <div
        className={`timer__label ${showLabel ? 'timer__label--visible' : 'timer__label--hidden'
          }`}
      >
        <p className="timer__date">
          Today is {labelText.dayOfWeek}, {labelText.month}{' '}
          {labelText.dayOfMonth}.
        </p>
      </div>
    </div>
  );
}

export default HandleTimer;